type Severity = "error" | "info" | "warning";

interface LogParams {
  /**
   Message to be logged.
   */
  message: any;
  /**
   Available options: "error" | "info" | "warning"
   */
  severity?: Severity;
  /**
   Full javascript error
   */
  error?: Error;
}

const addLog = ({ message, severity = "error", error }: LogParams): void => {
  const logDate = new Date().toISOString();
  const logMessage = JSON.stringify(message);

  switch (severity) {
    case "error":
      // @ts-ignore
      console.trace(`ERROR ${logDate} | ${logMessage}`);
      break;
    case "info":
      console.log(`INFO ${logDate} | ${logMessage}`);
      break;
    case "warning":
      console.warn(`WARN ${logDate} | ${logMessage}`);
      break;
    default:
      console.log(`INFO ${logDate} | ${logMessage}`);
  }
};

export default addLog;
